module.exports = __webpack_public_path__ + "media/images/btn_hatena-f3d6c8784af14477a624f622ad6208a9.png";